var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collect-container"},[_c('TopList',{attrs:{"navList":_vm.navList},on:{"setType":_vm.setType}}),(_vm.type === 0)?_c('Collect1'):(_vm.type === 1)?_c('Collect2'):(_vm.type === 2)?_c('Collect3'):(_vm.type === 3)?_c('CollectMeeting'):_c('CollectCourse')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }